import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Applications from "./components/Applications";
import Catalog from "./components/Catalog";
import Advantages from "./components/Advantages";
import Certifications from "./components/Certifications";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Location from "./components/Location";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import CookieBanner from "./components/CookieBanner";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";

// Componente para la página principal
const HomePage = () => (
  <>
    <Hero />
    <About />
    <Applications />
    <Catalog />
    <Advantages />
    <Services />
    <Certifications />
    <FAQ />
    <Contact />
    <Location />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/aviso-legal" element={<LegalNotice />} />
            <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
            <Route path="/politica-cookies" element={<CookiePolicy />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <CookieBanner />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
